import type React from 'react';

import { DeleteIcon } from '@vlabs/icons';
import { Tooltip } from '@vlabs/uikit';
import type { IconButtonProps } from '@vlabs/uikit/components/controls/button/icon-button';
import { IconButton } from '@vlabs/uikit/components/controls/button/icon-button';
import type { WithDataTestid } from '@vlabs/uikit/types';

import { buildTestid } from '@vlabs/monokit/shared/lib/utils';

import { confirmDeleteStreams } from './confirm/confirmDeleteStreams';
import { useDeleteStreams } from './useDeleteStreams';
import { useDeleteStreamTranslation } from '../i18n';
import type { DeleteStreamsProps } from '../types';

const displayName = 'DeleteStreamsIconButton';
const testid = buildTestid(displayName);

interface DeleteStreamsIconButtonProps extends DeleteStreamsProps, WithDataTestid, IconButtonProps {}

function DeleteStreamsIconButton({
  streamIds,
  onSuccess = undefined,
  'data-testid': dataTestId = undefined,
  ...props
}: DeleteStreamsIconButtonProps): React.JSX.Element {
  const { t } = useDeleteStreamTranslation();
  const { onDelete } = useDeleteStreams({ streamIds, onSuccess });

  return (
    <Tooltip tooltipContent={t('title')}>
      <IconButton
        icon={<DeleteIcon />}
        kind="secondary"
        onClick={() => confirmDeleteStreams({ onConfirm: onDelete })}
        variant="flat"
        {...testid(dataTestId)}
        {...props}
      />
    </Tooltip>
  );
}

DeleteStreamsIconButton.displayName = displayName;

export { DeleteStreamsIconButton };
